export default "__VITE_ASSET__Re589Qwz__"